<template>
  <div>

    <md-dialog-alert
      :md-active.sync="error.show"
      :md-title="error.title"
      :md-content="errorMessage(error.error)"
      md-confirm-text="Ok"/>

    <md-progress-bar v-if="order.pending" class="md-accent" md-mode="query"/>

    <md-content>
      <md-field style="float: left">
        <label>Номер заказа</label>
        <md-input v-model="barCode"/>
        <span class="md-helper-text">Заказ в ТД / Бар-код / Номера заказа ИМ</span>
      </md-field>

      <md-button class="md-raised md-primary" v-on:click="searchOrder">Поиск</md-button>

      <md-button class="md-icon-button md-primary" v-on:click="scan">
        <md-icon>camera_alt</md-icon>
      </md-button>

    </md-content>

    <app-stream-scanner v-if="scanner" :onDetected="logIt" :readerSize="readerSize"/>
    <app-order v-if="order.order" v-bind:order="order"/>

  </div>
</template>

<script>
  import StreamScanner from '../components/StreamScanner';
  import Order from "./Order";

  export default {
    name: "SearchOrder",
    data() {
      return {
        scanner: false,
        readerSize: {
          width: 800,
          height: 600
        },
        barCode: '',
      }
    },
    mounted() {
      this.$store.commit({
        type: 'setOrder',
        order: null,
      });
    },
    methods: {
      scan() {
        this.scanner = !this.scanner;
        if (this.scanner) {
          this.$store.commit({
            type: 'setOrder',
            order: null,
          });
        }
      },
      errorMessage(error) {
        return this.$store.getters.getErrorMessage(error)
      },
      logIt(data) {
        this.barCode = data.codeResult.code;
        this.scanner = false;
        this.searchOrder();
      },
      searchOrder: function (event) {
        this.scanner = false;
        this.selectStatus = false;
        this.$store.commit({
          type: 'setOrder',
          order: null,
        });

        this.$store.commit({
          type: 'setPendingOrders',
          pending: true,
        });

        this.$store.getters.getWSConnectState.ws.send(JSON.stringify({
          event: "getOrder",
          data: this.barCode,
        }));
      },
    },
    computed: {
      order() {
        return this.$store.getters.getOrder
      },
      user() {
        return this.$store.getters.getUser
      },
      error() {
        return this.$store.getters.getErrorByMethod('getOrder');
      },
    },
    components: {
      AppOrder: Order,
      AppStreamScanner: StreamScanner,
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/SearchOrder.vue